var _rect, _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeanerIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666748,
    width: 48,
    height: 48,
    rx: 12,
    fill: "#EFF6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_421_9941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 34.6667H39.6666V24H10.3333V34.6667ZM11.6666 25.3333H38.3333V33.3333H36.9999V29.3333H35.6666V33.3333H34.3333V30.6667H32.9999V33.3333H31.6666V26.6667H30.3333V33.3333H28.9999V30.6667H27.6666V33.3333H26.3333V29.3333H24.9999V33.3333H23.6666V30.6667H22.3333V33.3333H20.9999V26.6667H19.6666V33.3333H18.3333V30.6667H16.9999V33.3333H15.6666V29.3333H14.3333V33.3333H11.6666V25.3333ZM35.6666 13.3333V14.6667H14.3333V13.3333H10.3333V17.3333H14.3333V16H35.6666V17.3333H39.6666V13.3333H35.6666ZM12.9999 16H11.6666V14.6667H12.9999V16ZM38.3333 16H36.9999V14.6667H38.3333V16Z",
    fill: "#2A67EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_421_9941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(9 8)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeanerIcon);
export default __webpack_public_path__ + "static/media/leanerIcon.73ac579e3fbaa7cebedf707999c0ffca.svg";
export { ForwardRef as ReactComponent };